import React from 'react';
const activities = [{
  title: 'Documentary & Film',
  description: 'Supporting documentary projects that explore consciousness, human potential, science, and culture.'
}, {
  title: 'Research',
  description: 'Supporting bold and unconventional research into the brain, consciousness, and human potential.'
}, {
  title: 'Arts & Culture',
  description: 'Supporting creative projects that explore human experience and perception.'
}, {
  title: 'Education & Knowledge Sharing',
  description: 'Making complex scientific ideas accessible to a wider audience.'
}, {
  title: 'Human Performance',
  description: 'Exploring the relationship between the brain, body, consciousness, and performance.'
}];
export function Activities() {
  return <section aria-labelledby="activities-title" data-id="element-7" data-mp="1llx94emdm14m">
      <h2 id="activities-title" className="mb-10 text-center text-2xl font-bold" data-id="element-8" data-mp="1poaf9451c11x">
        Activities
      </h2>
      <div className="grid gap-x-12 md:grid-cols-2" data-id="element-9" data-mp="1zuiyxrh99u4j">
        {activities.map(activity => <article key={activity.title} className="border-t border-white/30 py-6 last:md:col-span-2" data-id="element-10" data-mp="1uvxzhu9tveh5">
            <h3 className="mb-2 text-xl font-semibold" data-id="element-11" data-mp="1pvaa1d18z5p1">{activity.title}</h3>
            <p className="text-base leading-7 text-white/85" data-id="element-12" data-mp="1lvjekw0s01e6">
              {activity.description}
            </p>
          </article>)}
      </div>
    </section>;
}